module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "input",
      "validation": "required"
    },
    model: {
      value: (_vm.temperature.name),
      callback: function($$v) {
        _vm.$set(_vm.temperature, "name", $$v)
      },
      expression: "temperature.name"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-477a37d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/Tasks/Temperature.vue
// module id = 620
// module chunks = 1